import * as yup from "yup";

import type { TFunction } from "i18next";

/** Valores validados de la carga manual de factura. */
export interface ChargedInvoiceValues {
  ccEmail?: string | null;
  invoiceDate: Date;
  invoiceNumber: string;
  total: string;
}

/**
 * Fábrica del esquema de validación para la carga manual de factura.
 * Recibe `t` porque los mensajes de error usan claves de i18n.
 */
export const buildChargedInvoiceSchema = (t: TFunction): yup.ObjectSchema<ChargedInvoiceValues> =>
  yup.object().shape({
    ccEmail: yup.string().email(t("mailValid")),
    invoiceDate: yup.date().required(t("isRequired")),
    invoiceNumber: yup.string().required(t("isRequired")),
    total: yup.string().required(t("isRequired")),
  }).required();
